import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class EcoFuture {

  // PV

    public pvInverter: number | null = null;

    public pvInverterAcdcRatio: number | null = null;

    // Generator

    public generatorBeforeDayCost: number | null = null;

    public generatorBeforeNightCost: number | null = null;

    public generatorAfterDayCost: number | null = null;

    public generatorAfterNightCost: number | null = null;

    public generatorCostType1: number | null = null;

    public generatorCostType2: number | null = null;

    // Battery

    public batteryModule: number | null = null;

    public batteryPriceReduction: number | null = null;

    public batteryInverter: number | null = null;

    public constructor(obj: ObjectOnly = {}) {
      assignToThis(this, obj);
    }

}
